import { useCallback } from "react";

import { useDashboardLanguage } from "../context/DashboardLanguageContext";
import type { DashboardLanguage } from "../types";
import {
  translateDashboardKey,
  type TranslationTree,
} from "../utils/translations/translationTypes";

type TranslationMap = Record<DashboardLanguage, TranslationTree>;

export function useDashboardTranslate<T extends TranslationMap>(map: T): (key: string) => string {
  const { language } = useDashboardLanguage();

  return useCallback((key: string) => translateDashboardKey(map, language, key), [language, map]);
}
